export default __webpack_public_path__ + "static/media/flower-1.ed0df46f.jpg";